import React, { Component } from "react";
import Table from "../../../common/table";
import { Link, withRouter } from "react-router-dom";
import moment from "moment";

class ForumCategoriesTable extends Component {
  columns = [
    {
      key: "checkbox",
      //label: <input type="check" style={checkboxStyles} />,
      label: (
        <input
          type="checkbox"
          style={{
            width: "15px",
            height: "15px",
            marginTop: "0.4rem",
            borderRadius: 0,
          }}
          onChange={this.props.handleSelectAll}
        />
      ),
      content: (cat) => (
        <span className="icon-img sm-r-5" style={{ marginTop: "15px" }}>
          <input
            type="checkbox"
            style={checkboxStyles}
            onChange={this.props.handleCheckboxChange}
            value={cat._id}
            checked={this.props.checkedFields.includes(cat._id)}
          />
        </span>
      ),
    },
    { label: "Name", path: "name" },
    {
      label: "User",
      content: (cat) => (
        <>
          <img src={cat?.user?.imageSrc} alt="" width={20} />
          <p>{cat.user?.username}</p>
        </>
      ),
    },
    { label: "Description", path: "description" },
    { label: "Status", path: "status" },
  ];

  render() {
    //console.log(this.columns) ;
    const { forumCategories, onSort, sortColumn } = this.props;
    return (
      <Table
        columns={this.columns}
        sortColumn={sortColumn}
        onSort={onSort}
        data={forumCategories}
      />
    );
  }
}

const checkboxStyles = {
  width: "15px",
  height: "15px",
  marginTop: "0.4rem",
  borderRadius: 0,
};

export default ForumCategoriesTable;
